/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Karol Pawlak <kpa@giap.pl>, September 2022
 */
import React, { PropTypes } from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './NotReady.css';

class CreatedServiceNotReady extends React.Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
  };

  render() {
    return (
      <div className={s.root}>
        <div className={s.container}>
          {this.props.title ? <h1>{this.props.title}</h1> : null}
          <div
            className={s.napis}
          >
          Wybrana e-usługa nie została odpowiednio przygotowana przez Urząd lub jest w trakcie tworzenia.
          Prosimy o kontakt z Urzędem.
          </div>
        </div>
      </div>
    );
  }
}

export default withStyles(s)(CreatedServiceNotReady);



// WEBPACK FOOTER //
// src/routes/CreatedServiceNotReady/CreatedServiceNotReady.js